import React from 'react'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { SearchFiltersSwitch } from '../../components/search-filters-switch/search-filters-switch'
import { IconCalendar } from '@at/design-system-icons'
import { atdsTheme, ThemeSelectors } from '@at/design-system-foundation'

const LeaseInStock = withFacetContext(
    FacetName.lease_in_stock,
    withFilterContext(FilterName.lease_in_stock, SearchFiltersSwitch, {
        title: 'In stock and available now',
        defaultSelected: true,
        icon: (
            <IconCalendar
                title="In stock and available now"
                fill={ThemeSelectors.getCopyColor(atdsTheme)}
                customSize={{ height: 18, width: 18 }}
            />
        ),
    })
)

export const LeaseInStockToggle = () => {
    return <LeaseInStock />
}
